import { currencies } from '@tango/app/assets/constants';
import {
  accountRequisites,
  credit,
  transactionReceipt,
  transactionsHistory,
} from '@tango/app/assets/definitions';
import { DEFAULT_CONFIG } from '@tango/app/config';
import { merge } from 'lodash';
import { bankLogo } from '../assets/base64-images/bank-logo';
import {
  appPublisherName,
  appVersion,
  bankAddress,
  bankChairpersonName,
  bankChairpersonTitle,
  bankLinks,
  bankName,
  bankSupportPhone,
  clientVersion,
  colorValues,
  rootUrl,
  usernameFormat,
  widgetsNames,
} from '../assets/constants';
import { icons } from '../assets/icons';
import { environment } from '../environments/environment';
import { BankAppConfig } from './app.config';

export const CONFIG: BankAppConfig = merge({}, DEFAULT_CONFIG, <BankAppConfig>{
  apiEndpoint: environment.production ? document.location.origin : rootUrl,
  svgIcons: icons,
  bankLogo,
  bankName,
  bankSupportPhone,
  bankLink: bankLinks.parentBank,
  bankAddress,
  bankChairpersonTitle,
  bankChairpersonName,
  colorValues,
  definitions: {
    transactionReceipt,
    transactionsHistory,
    credit,
    accountRequisites,
  },
  mobileButtons: {
    android: {
      active: true,
      link: bankLinks.googlePlay,
    },
    ios: {
      active: true,
      link: bankLinks.appStoreLink,
    },
  },
  defaultRoute: 'dashboard',
  showNotifications: true,
  notifications: { bank: true },
  showProfileInfo: true,
  iconizeKindedFooter: true,
  allowDemoMode: true,
  allowNoCredentialsAuth: false,
  ui: {
    transactionDetails: true,
    holdDetails: true,
    depositHistoryDetails: true,
    widgets: widgetsNames,
  },
  currencies: {
    commercial: [currencies.eur, currencies.usd, currencies.gbp],
    card: [currencies.eur, currencies.usd],
  },
  currenciesWidget: {
    cardRatesTab: true,
    converterTab: false,
  },
  usernameFormat,
  profile: {
    updateInfoEnabled: true,
    settingsEnabled: false,
    passwordChangeEnabled: true,
    passwordChangeBtnColor: 'accent-additional',
    appInfoShown: true,
  },
  appVersion,
  clientVersion,
  cardOderEnabled: false,
  appPublisherName,
  demoCredentials: {
    username: null,
    password: null,
  },
  resetPassword: true,
  registrationEnabled: true,
  hasIdentification: true,
  requireIdentification: true,
  signupConditionsLink:
    'https://poltavabank.com/platizhni-kartky/#1599833079089-ac012fab-7041',
  paymentTemplates: {
    show: true,
  },
  periodicPayments: {
    show: true,
    showOneTimeTab: false,
    allowWeeklyPayment: true,
    allowOneTimePayment: false,
  },
  apiVersion: { deposits: '3' },
  newDeposit: true,
  currencyExchange: {
    show: true,
    includeCards: false,
    includeAccounts: true,
  },
  account2card: {
    hasTokenCards: false,
  },
  token2account: {
    show: true,
  },
  accounts: {
    moduleVer: '2',
    hasRequisitesLink: true,
  },
  cards: {
    hasCreditLimitSettings: false,
  },
  featureToggles: {
    hasVirtualCardOrder: false,
    hasVirtualReissue: false,
  },
});
